import { render } from "./MdvContactButton.vue?vue&type=template&id=a6d41408&scoped=true"
import script from "./MdvContactButton.vue?vue&type=script&lang=js"
export * from "./MdvContactButton.vue?vue&type=script&lang=js"

import "./MdvContactButton.vue?vue&type=style&index=0&id=a6d41408&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d41408"]])

export default __exports__